module.exports = __webpack_public_path__ + "static/mobile@2x-150x150-76f07a774ba3bf42f5e99fd929b831e2.png";